import { useFormikContext } from "formik";
import React, { useEffect } from "react";
import { ProductInput } from "@me-team/host/main/graphql/types";

const CreateProductFormEffects: React.FC<{
    pickedCategoryId: number | null;
    setSelectedMainUnitId: (id: number) => void;
}> = ({ pickedCategoryId, setSelectedMainUnitId }) => {
    const { setFieldValue, values } = useFormikContext<ProductInput>();

    useEffect(() => {
        if (pickedCategoryId) {
            setFieldValue("category", pickedCategoryId);
        }
    }, [pickedCategoryId, setFieldValue]);

    useEffect(() => {
        if (values.unit) {
            setSelectedMainUnitId(values.unit);
        }
    }, [values.unit, setSelectedMainUnitId]);

    return null;
};

export default CreateProductFormEffects;
